import { arrayToObject } from "../helpers/arrayHelper";
import { COUNTRIES } from "./countries";
import { PROFESSIONS } from "./profileSetupEnums";

export const MAX_CHAR_BIO = 1000;

export const DESC = 'desc';
export const ASC = 'asc';

export const INITIAL_GET_PARAMS = Object.freeze({
  page: 1,
  order_by: 'created_at',
  per_page: 20,
  sort_by: DESC
});

export const DECLINE_CHECKLIST = Object.freeze([
  'Incomplete Information',
  'Insufficient Experience',
  'Inconsistent Information',
  'Poor Fit',
  'Low Quality of Work',
  'Others'
]);

export const EDIT_CHECKLIST = Object.freeze([
  'Tiktok URL',
  'Biography',
  'Others'
]);

export const DECLINE_FIELDS = 'decline_fields';
export const REQUEST_EDIT_FIELDS = 'edit_fields';

export const COLLAB_INTEREST = 'collab_interest';
export const CONTENT_INTEREST = 'content_interest';

export const COLLAB_INTEREST_SFW = 'collab_interest_sfw';
export const CONTENT_INTEREST_SFW = 'content_interest_sfw';
export const COLLAB_INTEREST_NSFW = 'collab_interest_nsfw';
export const CONTENT_INTEREST_NSFW = 'content_interest_nsfw';

export const PLATFORMS_KEY = 'platforms';
export const SOCIALS_KEY = 'socials';
export const TAGS_KEY = 'tags';

export const SFW_KEY = 'sfw';
export const NSFW_KEY = 'nsfw';

export const EDIT_PROFILE_LABEL = 'Edit Profile';

export const NEW_COLLAB_REQUEST_TITLE = 'New Collab Request';

export const NOTIFICATIONS_MESSAGE = Object.freeze({
  [NEW_COLLAB_REQUEST_TITLE]: 'has sent you a collab invitation.',
  'Collab Accepted': 'has accepted your collab.',
  'Collab Declined': 'has declined your collab.',
  'Collab Canceled': 'has canceled collab.',
});

export const GENERIC_COLUMN_PROPS = Object.freeze({
  editable: false,
  sortable: false,
  resizable: false
});

export const ADMIN_ROLE = 'admin';
export const DEVELOPER_ROLE = 'developer';
export const CREATOR_ROLE = 'creator';
export const PENDING_CREATOR_ROLE = 'pending_creator';

export const ROLES = Object.freeze([ADMIN_ROLE, DEVELOPER_ROLE]);

export const MEN_KEY = 'Men';
export const WOMEN_KEY = 'Women';
export const TRANS_KEY = 'Trans';
export const PHOTOGRAPHER_KEY = 'Trans';

export const TAGS_PROF = Object.freeze(arrayToObject(PROFESSIONS, 'profession'));
export const TAGS_LOCATION = Object.freeze(arrayToObject(COUNTRIES, 'country'));

export const SPECIAL_POPULAR_TAGS = Object.freeze({
  TAGS: [MEN_KEY, WOMEN_KEY, TRANS_KEY, ...PROFESSIONS, ...COUNTRIES],
  [MEN_KEY]: {
    gender: 'male'
  },
  [WOMEN_KEY]: {
    gender: 'female'
  },
  [TRANS_KEY]: {
    gender: 'trans'
  },
  ...TAGS_PROF,
  ...TAGS_LOCATION
});

export const COLLAB_KEY = 'Collab';
export const SELECTED = 'selected';
export const ALL = 'all';

export const MAX_CHARS = 300;